import React, {useState, useEffect} from "react";
import { useOutletContext } from "react-router-dom";
import orderApi from "../../../services/Order/orderApi";
import { DEPOSIT_CHARGE_URL, MY_PAGE_DEPOSIT_TOTAL_URL } from "../../../utils/urls";
import instance from "../../../services/services";
import { formatLocalString, numericRegex } from "../../../utils/validation";
import PopupLoginError from "../../../components/Popup/LoginError";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../hooks/useLanguage";
import { useFooterData } from "../../../components/Footer/FooterContext";

function DepositCharge(){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { myInfo } = useOutletContext();
  const [deposit, setDeposit] = useState(0);
  const [applyName, setApplyName] = useState('');
  const [depositAmount, setDepositAmount] = useState('');
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);
  const [depositTotal, setDepositTotal] = useState(0);
  const { footerData } = useFooterData();

  // 입금할 은행 정보
  useEffect(() => {
    const fetchDeposit = async () => {
      const response = await orderApi.getDepositList();
      setDeposit(response.data.data);
    };
    fetchDeposit();
  }, []);

  const handleDepositCharge = async () => {
    // 입력값 검증
    if (!applyName) {
      setIsPopupLoginError(t('deposit_info_1'));
      return; // 함수 종료
    }

    if (!depositAmount) {
      setIsPopupLoginError(t('deposit_info_2'));
      return; // 함수 종료
    }

    // 서버에 요청
    try {
      const response = await instance.post(DEPOSIT_CHARGE_URL, {
        apply_name: applyName,
        balance: depositAmount,
      });

      if (response.data.code === 200) {
          setIsPopupLoginError({
              message: t('deposit_info_3') + '<br/>' + t('deposit_info_4'),
              action: 'navigate_login'
          });
      }
    } catch (error) {
      console.error('입금 신청 중 오류:', error);
      setIsPopupLoginError('입금 신청에 실패했습니다. 다시 시도해주세요.');
    }
  };

  const handleDepositAmountChange = (e) => {
    // 콤마 제거 후 숫자가 아닌 문자 모두 제거
    const value = numericRegex(e.target.value.replace(/,/g, ''));
    setDepositAmount(value); // 숫자만 있는 값으로 상태 업데이트
  };
  // 팝업 확인 버튼 클릭 핸들러 추가
  const handleConfirm = () => {
    if (isPopupLoginError.action === 'navigate_login') {
      navigate('/myPage/deposit'); // 페이지 이동
    }
    setIsPopupLoginError(false); // 팝업 닫기
  };

  // 총 예치금 조회
  useEffect(() => {
    const fetchDepositTotal = async () => {
      const response = await instance.post(MY_PAGE_DEPOSIT_TOTAL_URL);
      setDepositTotal(response.data.data.balance);
    };
    fetchDepositTotal();
  }, []);



  return(
    <div>
      <div className="my_container point_container mt_48">
        <div className="order_title">
          <h3>{t('deposit_info_14')}</h3>
        </div>
        <ul className="default_info_table v2 payment deposit_form">
          <li className="info_item">
            <div className="label">
              <label htmlFor="use_name">{t('deposit_info_15')}</label>
            </div>

            <div className="form_info">
              <div className="info_detail">
                <div className="default_input">
                  <input
                    id="use_name"
                    placeholder={myInfo?.user_name || ''}
                    type="text"
                    value={applyName}
                    onChange={(e) => setApplyName(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </li>
          
          <li className="info_item">
            <div className="label">
              <label htmlFor="use_deposit">{t('deposit_info_16')}</label>
            </div>

            <div className="form_info">
              <div className="info_detail deposit_amount">
                <div className="deposit_input">
                  <div className="default_input comb-input">
                    <input
                      id="use_deposit"
                      placeholder="0"
                      type="text"
                      value={depositAmount ? formatLocalString(depositAmount) : ''}
                      onChange={handleDepositAmountChange}
                    />
                    <i className="comb_btn-right">{t('price_txt')}</i>
                  </div>
                  
                  <p className="text_small_b flex-center-4">
                    <span className="g-80">{t('deposit_info_17')}</span>
                    <span>
                      {formatLocalString(depositTotal)}
                      <i className="quo_count">{t('price_txt')}</i>
                    </span>
                  </p>
                </div>
                <p className="flex-2 column">
                  <span className="guide_text_1 g-80">
                    {t('account_holder')}: {deposit?.depositor}
                  </span>
                  <span className="guide_text_1 g-80">
                    {t('deposit_info_19')}: {deposit?.bank} {deposit?.account}
                  </span>
                </p>
              </div>
            </div>
          </li>
        </ul>

        {/* 예치금 안내 */}
        <div className="bottom_info_box alert_box gray">
          <h6 className="strong_b1">{t('deposit_info_20')}</h6>
          <p className="px-4 dash_list flex-2 column">
            <span className="guide_text_1 g-80">
              {t('deposit_info_21')}
            </span>
            <span className="guide_text_1 g-80">
              {t('deposit_info_22')}
            </span>
            <span className="guide_text_1 g-80">
              {t('deposit_info_70', {footerData: footerData?.csMainPhone?.value})}
            </span>
          </p>
        </div>

        {/* 충전하기 */}
        <div className="submit_box mt_48 bg">
          <button 
            type="button"
            className="default_btn lg black" 
            onClick={handleDepositCharge}
          >
            {t('charge')}
          </button>
        </div>
      </div>
      <PopupLoginError isPopup={isPopupLoginError} setIsPopup={setIsPopupLoginError} onConfirm={handleConfirm}/>


    </div>
  )
};

export default DepositCharge;